import React from 'react';

import event from './img/icon-pt2-event-circle.png';

import { i18n } from '../../i18n';

import SectionHeader from '../../section-header';
import Screenshot    from '../../screenshot';
import ModalImage    from '../../modal-image';

import * as css from './index.module.css';

const prefix = 'part2.e';

export default function Events() {
    return <>
        <SectionHeader name="events" />

        <div className='section'>
            <div className={css.cols}>
                <div className={css.col}>
                    <p>{i18n(`${prefix}.para.0`)}</p>
                    <p>{i18n(`${prefix}.para.1`)}</p>

                    <div className={css.iconWrap}>
                        <img src={event} />
                        <p>{i18n(`${prefix}.para.2`)}</p>
                    </div>
                </div>

                <ModalImage path={`${prefix}.modal`}>
                    <Screenshot path={`${prefix}.img`} />
                </ModalImage>
            </div>
        </div>
    </>;
}

